const $ = window.jQuery;

const buildStars = () => {
    for (const starElement of document.querySelectorAll('.js-stars')) {
        if (starElement.classList.contains('is-loaded')) {
            continue
        }

        const updateInput = starElement.dataset.updateInput
        const readOnly = !updateInput
        const useFullStars = updateInput

        let settings = {
            starSize: starElement.dataset.size || 20,
            initialRating: starElement.dataset.stars * 5 / 100,
            readOnly: readOnly,
            useFullStars: useFullStars,
            emptyColor: '#F4BBB7',
            hoverColor: '#E25448',
            activeColor: '#E25448',
            ratedColor: '#E25448',
            strokeColor: 'transparent',
            useGradient: false,
            disableAfterRate: false
        }

        if (updateInput) {
            settings.callback = (currentRating, el) => {
                document.querySelector(updateInput).value = currentRating
            }
        }

        $(starElement).starRating(settings)
        starElement.classList.add('is-loaded')
    }
}

export { buildStars }
